import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetGroup } from '../../../store/GroupAction';
import * as Tab from '../../../util/TabValue';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import RenderTabs from '../../misc/Tabs';
import GroupViewObjectLogs from './GroupViewObjectLogs';
import GroupViewInfo from './GroupViewInfo';
import GroupViewMembers from './GroupViewMembers';
import GroupViewActivities from './GroupViewActivities';
import GroupViewTrackings from './GroupViewTrackings';
import NotFound from '../components/NotFound';
import { CoreStudentGroup } from '../../../models/CoreGroup';
import { RequestState } from '../../../models/RequestState';
import StatusCode from '../../../util/StatusCode';
import Loading from '../../misc/Loading';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';
import DeleteDate from '../../misc/DeleteDate';
import * as Helper from '../../../util/Helper';


const GroupView = () => {
    const { t } = useTranslation('common');
    const { groupId } = useParams();
    const dispatch = useDispatch();
    const group = useSelector<RootState, RequestState<CoreStudentGroup>>(state => state.groups.group);

    useEffect(() => {
        if (groupId !== undefined) {
            GetGroup(groupId)(dispatch);
        }
    }, [dispatch, groupId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.ObjectLogs,
        Tab.Tabs.Members,
        Tab.Tabs.Activities,
        Tab.Tabs.Trackings,
    ];

    if (groupId === undefined) {
        return;
    }

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/group">{t('object.schoolAdmin.group', { ns: 'common', count: 1 })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (group.code) {
        case StatusCode.COMPLETE:
            displayName = group.data.title;
            return (renderContent(<>

                {group.data.removeDate && <DeleteDate message={t('deleteDate.group', { ns: 'schoolAdministration', date: Helper.formatDateOnly(group.data.removeDate) })} />}

                <RenderTabs
                    tabs={tabs}
                    id={groupId}
                    url="group" />

                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<GroupViewInfo />} />
                        <Route path={Tab.Tabs.ObjectLogs.url} element={<GroupViewObjectLogs />} />
                        <Route path={Tab.Tabs.Members.url} element={<GroupViewMembers />} />
                        <Route path={Tab.Tabs.Activities.url} element={<GroupViewActivities />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<GroupViewTrackings />} />
                        <Route path="*" element={<Navigate replace={true} to={`/group/${groupId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));
        case StatusCode.ERROR:
            if (group.error.response?.status === 404 || group.error.response?.status === 400) {
                return (
                    <NotFound
                        header={t('object.schoolAdmin.group', { ns: 'common', count: 1 })}
                        translateKey={{ i18nKey: "notFound.group", ns: "schoolAdministration" }}
                        link="/group"
                    />
                );
            } else {
                return renderContent(<p> {group.error.response?.statusText}</p>);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default GroupView;
